import { type Record as RecordType } from '@/schemas/API/GET/billing/record/response';
import { type UpdateBillingRecord } from '../API/PUT/billings/records/request';

export const convertToPutRecord = (
  billingRecord: RecordType | undefined
): UpdateBillingRecord => {
  if (!billingRecord) throw new Error('billingRecord is undefined');
  const { id, emps, totalPrice, manual, ...putRecord } = billingRecord;
  const ids = emps?.map(emp => emp.id);
  return { empIds: ids, ...putRecord };
};
